import axiosInstance from "./axiosInstance";

// const getInstitutionType = async () => {
//   try {
//     const response = await axiosInstance.get('/inst-type');
//     return response.data.data;
//   } catch (error) {
//     throw error.response.data;
//   }
// };

let institutionTypeCache = null;
console.log(axiosInstance, "axiosInstance");
const getInstitutionType = async () => {
  try {
    if (institutionTypeCache) {
      // console.log('Returning cached data');
      return institutionTypeCache;
    }

    const response = await axiosInstance.get("/inst-type");
    institutionTypeCache = response.data.data; // Cache the data
    return institutionTypeCache;
  } catch (error) {
    throw error.response.data;
  }
};

// const getInstitutionCategory = async (instType) => {
//   try {
//     const response = await axiosInstance.post('/inst-category',
//         {inst_type: instType}
//     );
//     return response.data.data;
//   } catch (error) {
//     throw error.response.data;
//   }
// };

const CACHE_EXPIRY_MINUTES = 60; // Cache for 1 hour

const getInstitutionCategory = async (instType) => {
  const CACHE_KEY = `institution_category_${instType}`;
  try {
    // Check cache
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      const { data, timestamp } = JSON.parse(cached);
      const now = new Date().getTime();
      if (now - timestamp < CACHE_EXPIRY_MINUTES * 60 * 1000) {
        // console.log(`Returning cached data for instType: ${instType}`);
        return data;
      }
    }

    // Fetch fresh data
    const response = await axiosInstance.post("/inst-category", {
      inst_type: instType,
    });
    const data = response.data.data;

    // Store in cache
    localStorage.setItem(
      CACHE_KEY,
      JSON.stringify({
        data,
        timestamp: new Date().getTime(),
      })
    );
    return data;
  } catch (error) {
    // Fallback to stale cache if available
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      // console.log(`API failed, returning stale cached data for instType: ${instType}`);
      return JSON.parse(cached).data;
    }
    throw error.response.data;
  }
};

// const showInstUnderCategory = async (instType, instCategory, currentPage, setLoading) => {
//   try {
//     setLoading(true)
//     const response = await axiosInstance.post(`/ibass/institutions?page=${currentPage}`,
//         {
//             inst_type: instType,
//             inst_category: instCategory,

//         }
//     );
//     return response.data.data;
//   } catch (error) {
//     throw error.response.data;
//   } finally {
//     setLoading(true)
//   }
// };

const showInstUnderCategory = async (
  instType,
  instCategory,
  currentPage,
  setLoading,
  searchTerm
) => {
  // const CACHE_KEY = `institutions_${instType}_${instCategory}_${currentPage}_${searchTerm}`;
  // try {
  //   setLoading(true);
  //   // Check cache
  //   const cached = localStorage.getItem(CACHE_KEY);
  //   if (cached) {
  //     const { data, timestamp } = JSON.parse(cached);
  //     const now = new Date().getTime();
  //     if (now - timestamp < CACHE_EXPIRY_MINUTES * 60 * 1000) {
  //       // console.log(`Returning cached data for instType: ${instType}, instCategory: ${instCategory}, page: ${currentPage}`);
  //       return data;
  //     }
  //   }

  // Fetch fresh data
  const response = await axiosInstance.post(
    `/ibass/institutions?page=${currentPage}`,
    {
      inst_type: instType,
      inst_category: instCategory,
      inst_search: searchTerm,
    }
  );
  const data = response.data.data;
  //  console.log(data)
  return data;

  // Store in cache
  // localStorage.setItem(CACHE_KEY, JSON.stringify({
  //   data,
  //   timestamp: new Date().getTime(),
  // }));
  // return data;
  // } catch (error) {
  //   // Fallback to stale cache if available
  //   const cached = localStorage.getItem(CACHE_KEY);
  //   if (cached) {
  //     // console.log(`API failed, returning stale cached data for instType: ${instType}, instCategory: ${instCategory}, page: ${currentPage}`);
  //     return JSON.parse(cached).data;
  //   }
  //   throw error.response.data;
  // } finally {
  //   setLoading(false); // Corrected to false to indicate loading complete
  // }
};

// const getProgrammesUnderInst = async (schoolId) => {
//   try {
//     const response = await axiosInstance.get(`/ibass/institution/programmes/${schoolId}?page=1`);
//     return response.data.data.data;
//   } catch (error) {
//     throw error.response.data;
//   }
// };

const getProgrammesUnderInst = async (
  schoolId,
  currentPage,
  setLoading,
  searchTerm
) => {
  // const CACHE_KEY = `programmes_${schoolId}_${currentPage}_${searchTerm}`;
  // try {
  //   setLoading(true);
  //   // Check cache
  //   const cached = localStorage.getItem(CACHE_KEY);
  //   if (cached) {
  //     const { data, timestamp } = JSON.parse(cached);
  //     const now = new Date().getTime();
  //     if (now - timestamp < CACHE_EXPIRY_MINUTES * 60 * 1000) {
  //       // console.log(`Returning cached data for schoolId: ${schoolId}`);
  //       return data;
  //     }
  //   }

  // Fetch fresh data
  const response = await axiosInstance.post(
    `/ibass/institution/programmes/${schoolId}?page=${currentPage}`,
    {
      course_search: searchTerm,
    }
  );
  const data = response.data.data;
  return data;

  // Store in cache
  // localStorage.setItem(CACHE_KEY, JSON.stringify({
  //   data,
  //   timestamp: new Date().getTime(),
  // }));
  // return data;
  // } catch (error) {
  //   // Fallback to stale cache if available
  //   const cached = localStorage.getItem(CACHE_KEY);
  //   if (cached) {
  //     // console.log(`API failed, returning stale cached data for schoolId: ${schoolId}`);
  //     return JSON.parse(cached).data;
  //   }
  //   throw error.response.data;
  // }
};
// const getEligibilityCheckerProgram = async (id) => {
//   const MAX_RETRIES = 2;
//   let retries = 0;

//   while (retries < MAX_RETRIES) {
//     try {
//       const response = await axiosInstance.get(
//         `/ibass/eligibility-checker/${id}`,
//         {
//           timeout: 15000,
//         }
//       );
//       console.log(response.data, "response.data.data");
//       return response.data.data;
//     } catch (error) {
//       retries++;
//       if (retries === MAX_RETRIES) {
//         console.error("Failed to fetch programs after retries:", error);
//         throw (
//           error.response?.data || {
//             message: "Failed to load programs. Please check your connection.",
//           }
//         );
//       }
//       await new Promise((resolve) => setTimeout(resolve, 1000 * retries));
//     }
//   }
// };
const getEligibilityCheckerProgram = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/ibass/eligibility-checker/${id}`
    );
    return response.data.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
const submitEligibilityChecker = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "/ibass/eligibility-checker/submit",
      payload
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export {
  getInstitutionType,
  getInstitutionCategory,
  showInstUnderCategory,
  getProgrammesUnderInst,
  getEligibilityCheckerProgram,
  submitEligibilityChecker,
};
